import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { VmsSearchConfig } from "@/api/elasticSearch/vmsSearchApi";
import { Search, defaultSearch } from "@/utilities/types/search";


interface SearchState {
    search: Search
    mapSearchArg?: VmsSearchConfig,
}

const initialState: SearchState = {
    search: defaultSearch,
    mapSearchArg: undefined,
};

export const esSearchBarSlice = createSlice({
    name: "searchBar",
    initialState,
    reducers: {
        setSearch(state, action: PayloadAction<Search>) {
            state.search = action.payload;
        },
        setMapSearchArg(state, action: PayloadAction<VmsSearchConfig>) {
            state.mapSearchArg = action.payload;
        },
    },
});

export const { setSearch, setMapSearchArg } = esSearchBarSlice.actions;
export const elasticSearchReducer = esSearchBarSlice.reducer;
